import { createSlice } from '@reduxjs/toolkit';
import { createPolicyCategory  , FetchAllPolicyCategory ,  UpdatePolicyCategory , FetchPolicyCategoryById ,DeletePolicyCategory} from './policyCategoryAction';
import { PolicyCategory ,PolicyCategoryState  } from './policyCategoryTypes';

const initialState : PolicyCategoryState ={
    policycategory : [],
    selectedpolicycategory : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}


const  PolicyCategorySlice = createSlice ({
    name : 'policycategory' ,
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
           .addCase(createPolicyCategory.pending, (state) => {
                                   state.loadingStates.create = true;
                                   state.errors.create = undefined;
                               })
                               .addCase(createPolicyCategory.fulfilled, (state, action) => {
                                   state.loadingStates.create = false;
                                   state.policycategory.push(action.payload);
                               })
                               .addCase(createPolicyCategory.rejected, (state, action) => {
                                   state.loadingStates.create = false;
                                   state.errors.create = action.payload as string;
                               })
                   
                               // Update 
                               .addCase(UpdatePolicyCategory.pending, (state) => {
                                   state.loadingStates.update = true;
                                   state.errors.update = undefined;
                               })
                               .addCase(UpdatePolicyCategory.fulfilled, (state, action) => {
                                   state.loadingStates.update = false;
                                   const index = state.policycategory.findIndex((d : any) => d.Id === action.payload.Id);
                                   if (index !== -1) {
                                       state.policycategory[index] = action.payload;
                                   }
                               })
                               .addCase(UpdatePolicyCategory.rejected, (state, action) => {
                                   state.loadingStates.update = false;
                                   state.errors.update = action.payload as string;
                               })
                   
                            //    // Delete 
                               .addCase(DeletePolicyCategory.pending, (state) => {
                                   state.loadingStates.delete = true;
                                   state.errors.delete = undefined;
                               })
                               .addCase(DeletePolicyCategory.fulfilled, (state, action) => {
                                   state.loadingStates.delete = false;
                                   state.policycategory = state.policycategory.filter((d : any) => d.Id !== action.payload);
                               })
                               .addCase(DeletePolicyCategory.rejected, (state, action) => {
                                   state.loadingStates.delete = false;
                                   state.errors.delete = action.payload as string;
                               })
                   
                               // Fetch  by ID
                               .addCase(FetchPolicyCategoryById.pending, (state) => {
                                   state.loadingStates.fetchById = true;
                                   state.errors.fetchById = undefined;
                               })
                               .addCase(FetchPolicyCategoryById.fulfilled, (state, action) => {
                                   state.loadingStates.fetchById = false;
                                   state.selectedpolicycategory = action.payload;
                               })
                               .addCase(FetchPolicyCategoryById.rejected, (state, action) => {
                                   state.loadingStates.fetchById = false;
                                   state.errors.fetchById = action.payload as string;
                               })
                   
                               // Fetch All 
                               .addCase(FetchAllPolicyCategory.pending, (state) => {
                                   state.loadingStates.fetchAll = true;
                                   state.errors.fetchAll = undefined;
                               })
                               .addCase(FetchAllPolicyCategory.fulfilled, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.policycategory = action.payload.data;
                               })
                               .addCase(FetchAllPolicyCategory.rejected, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.errors.fetchAll = action.payload as string;
                               }); 
    }
})

export default PolicyCategorySlice.reducer;